import { SEO_TDK_MAPPING_TYPES } from "@/constants/seo-constants";
import { Locale } from "@/i18n/config";

export const SEO_TDK_MAPPING: Partial<Record<Locale, SEO_TDK_MAPPING_TYPES>> = {
  en: {
    home: {
      /* prettier-ignore */
      "title": "AFun Mexico – Online Casino and Sports Betting with Exclusive Bonuses",
      /* prettier-ignore */
      "description": "Play at AFun Mexico, the leading online casino offering slots, live games, and sports betting. Enjoy exclusive bonuses and secure payments via SPEI, OXXO Pay, or Visa/Mastercard.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, sports betting, casino bonuses, live games, SPEI, OXXO Pay, Visa, Mastercard, gambling Mexico, welcome bonus",
    },
    casino: {
      /* prettier-ignore */
      "title": "AFUN Online Casino Mexico — Slots, Roulette, Blackjack & Sports Betting",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "online casino Mexico, slots, roulette, blackjack, live casino, sports betting, AFUN bonus, free spins",
    },
    profile: {
      /* prettier-ignore */
      "title": "AFun Profile – Manage Your Account, Balance and Betting History",
      /* prettier-ignore */
      "description": "Access your AFun Mexico profile to manage your account, view your betting history, and update your information. Enjoy secure deposits and withdrawals via SPEI, OXXO Pay, Visa, or Mastercard.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, user account, profile settings, betting history, deposits, withdrawals, SPEI, OXXO Pay, Visa, Mastercard",
    },
    collections: {
      /* prettier-ignore */
      "title": "AFun Collections – Explore the Best Slots and Casino Games",
      /* prettier-ignore */
      "description": "Discover AFun’s game collections with top slots, live casino titles, and themed jackpots. Enjoy exclusive bonuses and find your next favorite game today.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, slot games, live casino, jackpots, casino bonuses, gambling Mexico, popular games, free spins, exclusive rewards, casino online",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "AFun My Profile – Manage Your Account and Gaming History",
      /* prettier-ignore */
      "description": "Access your AFun profile to view your activity, update your personal information, and manage your bonuses. Keep your casino experience secure and personalized.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, user profile, account settings, gaming history, bonuses, rewards, player data, security, casino experience, gambling Mexico",
    },
    feedback: {
      /* prettier-ignore */
      "title": "AFun Feedback – Share Your Experience and Help Us Improve",
      /* prettier-ignore */
      "description": "Tell us what you think about AFun Mexico! Share your experience, suggest improvements, and help us make your casino journey even better. Your opinion matters to us.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, player feedback, user experience, customer support, casino reviews, opinions, suggestions, gambling Mexico, player satisfaction, contact",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "AFUN Personalized Games — Online Casino Mexico | Slots & Sports Betting",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "online casino Mexico, slots, sports betting, personalized games, live casino, AFUN bonus, blackjack",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "AFun Recent Games – Continue Playing Your Favorite Casino Slots",
      /* prettier-ignore */
      "description": "Quickly return to your favorite games at AFun Mexico. Access your recent slots, live tables, and jackpots in one place. Resume your play and keep your winning streak going.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, recent games, favorite slots, live casino, jackpots, player history, casino online, gaming experience, gambling Mexico, play again",
    },
    install: {
      /* prettier-ignore */
      "title": "AFun App – Download and Play Casino Games Anytime, Anywhere",
      /* prettier-ignore */
      "description": "Download the AFun Mexico App to enjoy slots, live casino, and sports betting on your phone. Experience fast performance, smooth gameplay, and exclusive mobile bonuses for new users.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, casino app, mobile betting, download app, slots, live casino, mobile gaming, exclusive bonuses, casino online, gambling Mexico",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "AFun Wager Contests – Bet on Events and Win Real Prizes",
      /* prettier-ignore */
      "description": "Join AFun Mexico’s wager contests! Bet on sports, climb the leaderboard, and win exciting rewards. Compete with other players in special events and claim exclusive bonuses.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, wager contests, sports betting, tournaments, leaderboard, casino bonuses, prizes, competitions, gambling Mexico, events",
    },
    tournament: {
      /* prettier-ignore */
      "title": "🏆 AFun Wager Contest - Compete for Exclusive Rewards",
      /* prettier-ignore */
      "description": "Join AFun’s wager contests. Climb the leaderboard, earn points and win exclusive rewards in slots and sports betting.",
      /* prettier-ignore */
      "keyword": "wager contest, casino competition, player leaderboard, exclusive rewards, sports betting",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "AFun Hot Games – The Most Popular Slots and Casino Hits in Mexico",
      /* prettier-ignore */
      "description": "Play the hottest casino games at AFun Mexico! Discover trending slots, live dealer tables, and jackpot titles loved by thousands of players.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, hot games, popular slots, live casino, jackpots, trending games, casino online, gambling Mexico, top games, player favorites",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "AFun Casual Games – Fun and Easy Casino Entertainment",
      /* prettier-ignore */
      "description": "Take a break with AFun Mexico’s casual games. Enjoy instant-play titles, quick fun, and exciting rewards without complex rules. Perfect for light and mobile gaming.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, casual games, instant play, fun games, mini games, easy casino, mobile gaming, entertainment, light slots, casino online",
    },
    vip: {
      /* prettier-ignore */
      "title": "AFun VIP Club – Exclusive Rewards, Cashback, and Premium Benefits",
      /* prettier-ignore */
      "description": "Join the AFun VIP Club in Mexico and unlock elite privileges: personal bonuses, weekly cashback, and faster withdrawals. Enjoy a truly premium casino experience for top players.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, VIP club, exclusive bonuses, cashback, rewards, loyalty program, premium casino, high rollers, player privileges, casino online",
    },
    providers: {
      /* prettier-ignore */
      "title": "AFun Game Providers – Play Certified Casino Games from Top Developers",
      /* prettier-ignore */
      "description": "Discover AFun Mexico’s official game providers, including Pragmatic Play, Evolution, NetEnt, and Microgaming. Enjoy certified slots, live casino, and trusted entertainment.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, game providers, Pragmatic Play, Evolution Gaming, NetEnt, Microgaming, certified games, live casino, trusted casino, software partners, slots",
    },
    responsible: {
      /* prettier-ignore */
      "title": "AFun Responsible Gaming – Play Safe and Stay in Control",
      /* prettier-ignore */
      "description": "At AFun Mexico, we promote responsible gaming. Set limits, take breaks, and enjoy casino entertainment safely. Learn about our player protection tools and support resources.",
      /* prettier-ignore */
      "keyword": "responsible gaming, online casino Mexico, player safety, self-control, gaming limits, gambling awareness, player protection, safe play, support, casino responsibility",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "AFun Bonus Center – Exclusive Casino Promotions and Player Rewards",
      /* prettier-ignore */
      "description": "Visit AFun Mexico’s Bonus Center to claim daily and weekly rewards. Enjoy deposit bonuses, free spins, and cashback tailored for loyal players. Don’t miss our limited-time promotions!",
      /* prettier-ignore */
      "keyword": "online casino Mexico, bonus center, casino bonuses, free spins, cashback, promotions, rewards, exclusive offers, player loyalty, gambling Mexico",
    },
    notify: {
      /* prettier-ignore */
      "title": "AFun Notifications – Stay Updated with the Latest Casino Alerts",
      /* prettier-ignore */
      "description": "Check your AFun Mexico notifications for the latest updates, bonuses, and event alerts. Never miss a promotion or reward — stay connected with your favorite casino.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, notifications, casino alerts, promotions, bonuses, updates, player messages, rewards, gambling Mexico, announcements",
    },
    menu: {
      /* prettier-ignore */
      "title": "AFun Menu – Explore All Casino Games, Promotions, and Features",
      /* prettier-ignore */
      "description": "Access the full AFun Mexico menu to explore casino games, bonuses, sports betting, and exclusive promotions. Your gateway to all entertainment sections in one place.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, site menu, casino games, promotions, sports betting, navigation, categories, casino online, gambling Mexico, player center",
    },
    settings: {
      /* prettier-ignore */
      "title": " AFun Settings – Manage Your Account, Privacy, and Notifications",
      /* prettier-ignore */
      "description": "Customize your AFun Mexico experience. Manage language preferences, update account information, and control privacy and notification settings for a secure casino environment.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, account settings, privacy, notifications, language preferences, user control, casino online, player security, personalization, profile management",
    },
    help: {
      /* prettier-ignore */
      "title": "AFun Help Center – FAQs and Player Support",
      /* prettier-ignore */
      "description": "Need assistance? Visit the AFun Mexico Help Center for FAQs, account guidance, and support. Our customer service team is available 24/7 to ensure your best casino experience.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, help center, support, FAQs, customer service, contact AFun, assistance, account help, casino online, player guide",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "AFun Bonus Games – Play Slots with Free Spins and Big Rewards",
      /* prettier-ignore */
      "description": "Explore AFun Mexico’s best bonus games. Enjoy free spins, multipliers, and jackpot rounds for massive wins. Experience the excitement of bonus slots today!",
      /* prettier-ignore */
      "keyword": "online casino Mexico, bonus games, free spins, bonus rounds, jackpot slots, multipliers, casino online, gambling Mexico, rewards, special features",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "AFun Affiliate Program – Earn with Mexico’s Leading Online Casino",
      /* prettier-ignore */
      "description": "Join the AFun Affiliate Program and start earning with one of Mexico’s top online casinos. Get high commissions, real-time tracking, and long-term revenue opportunities.",
      /* prettier-ignore */
      "keyword": "casino affiliate program, online casino Mexico, affiliate marketing, CPA, RevShare, commissions, gambling Mexico, partners, earn money online, casino promotion",
    },
    promotion: {
      /* prettier-ignore */
      "title": "AFun Promotions – Exclusive Casino Bonuses and Limited-Time Offers",
      /* prettier-ignore */
      "description": "Discover the latest promotions at AFun Mexico. Get welcome bonuses, free spins, and cashback rewards for active players. Don’t miss limited-time offers and weekly prizes!",
      /* prettier-ignore */
      "keyword": "online casino Mexico, promotions, bonuses, free spins, cashback, exclusive offers, casino rewards, gambling Mexico, active events, casino online",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    nobru: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "AFun Account Reset – Recover Your Login and Secure Access",
      /* prettier-ignore */
      "description": "Forgot your password? Use AFun Mexico’s reset page to recover your account safely. Follow simple steps to restore access and continue enjoying your casino experience securely.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, account reset, password recovery, secure access, login help, player support, casino online, recover account, safety, gambling Mexico",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "AFUNS Bonuses & Promotions – Rules and Terms",
      /* prettier-ignore */
      "description": "Explore AFUNS bonuses and promotions: learn the eligibility, wagering requirements, and terms to claim your rewards easily in our online casino.",
      /* prettier-ignore */
      "keyword": "AFUNS, casino bonuses, bonus rules, promotions, wagering requirements, online casino, Mexico",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "AFun Account Reset – Recover Your Login and Secure Access",
      /* prettier-ignore */
      "description": "Forgot your password? Use AFun Mexico’s reset page to recover your account safely. Follow simple steps to restore access and continue enjoying your casino experience securely.",
      /* prettier-ignore */
      "keyword": "online casino Mexico, sports betting, football odds, basketball, eSports, live betting, high odds, casino online, gambling Mexico, sports promotions",
    },
  },
  pt: {
    home: {
      /* prettier-ignore */
      "title": "AFun México – Cassino Online e Apostas Esportivas com Bônus Exclusivos",
      /* prettier-ignore */
      "description": "Descubra o AFun México, o cassino online mais confiável. Jogue caça-níqueis, roleta e esportes com bônus exclusivos. Pagamentos seguros via SPEI, OXXO Pay ou cartões Visa/Mastercard.",
      /* prettier-ignore */
      "keyword": "cassino online México, apostas esportivas, bônus exclusivos, SPEI, OXXO Pay, Visa, Mastercard, jogos ao vivo, diversão, prêmios",
    },
    casino: {
      /* prettier-ignore */
      "title": "AFUN Cassino Online México — Slots, Roleta e Jogos de Azar com Bônus",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "cassino online México, slots, roleta, blackjack, bônus de boas-vindas, apostas esportivas, cassino ao vivo",
    },
    profile: {
      /* prettier-ignore */
      "title": "AFun Perfil – Gerencie Sua Conta, Saldo e Histórico de Apostas",
      /* prettier-ignore */
      "description": "Acesse seu perfil AFun México para consultar histórico de apostas, gerenciar saldo e atualizar informações. Pagamentos seguros via SPEI, OXXO Pay ou cartões Visa/Mastercard.",
      /* prettier-ignore */
      "keyword": "cassino online México, conta do jogador, histórico de apostas, depósitos, retiradas, SPEI, OXXO Pay, Visa, Mastercard, segurança",
    },
    collections: {
      /* prettier-ignore */
      "title": "AFun Coleções – Descubra os Melhores Jogos de Cassino",
      /* prettier-ignore */
      "description": "Explore as coleções da AFun e encontre caça-níqueis populares, roleta ao vivo e jackpots temáticos. Aproveite bônus exclusivos e descubra novos jogos todos os dias.",
      /* prettier-ignore */
      "keyword": "cassino online México, caça-níqueis, jogos de cassino, jackpots, bônus exclusivos, jogos populares, apostas, diversão, jogos ao vivo, prêmios",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "AFun Meu Perfil – Controle Sua Conta e Histórico de Jogos",
      /* prettier-ignore */
      "description": "Acesse seu perfil AFun para consultar histórico, atualizar informações pessoais e gerenciar bônus. Tenha uma experiência segura e personalizada no cassino.",
      /* prettier-ignore */
      "keyword": "cassino online México, perfil do jogador, conta pessoal, histórico de jogos, bônus, recompensas, segurança, experiência, apostas, entretenimento",
    },
    feedback: {
      /* prettier-ignore */
      "title": "AFun Feedback – Compartilhe Sua Experiência e Ajude-nos a Melhorar",
      /* prettier-ignore */
      "description": "Conte sua experiência no AFun México! Envie sugestões, opiniões e comentários para tornar o cassino ainda melhor. Sua voz é essencial para nós.",
      /* prettier-ignore */
      "keyword": "cassino online México, feedback jogador, experiência do usuário, suporte ao cliente, opiniões, sugestões, confiança, satisfação, contato, avaliação",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "Jogos Personalizados AFUNS — Cassino Online México | Slots e Apostas Esportivas",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "cassino online México, slots, apostas esportivas, jogos personalizados, roleta, blackjack, bônus AFUNS",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "AFun Jogos Recentes – Continue Jogando Seus Favoritos",
      /* prettier-ignore */
      "description": "Volte aos seus jogos favoritos no AFun México. Continue jogando caça-níqueis, roleta e jogos ao vivo. Retome sua diversão e mantenha a sorte a seu favor.",
      /* prettier-ignore */
      "keyword": "cassino online México, jogos recentes, caça-níqueis, roleta, jogos ao vivo, histórico do jogador, experiência, diversão, apostas, prêmios",
    },
    install: {
      /* prettier-ignore */
      "title": "App AFun – Baixe e Jogue Cassino Online no Seu Celular",
      /* prettier-ignore */
      "description": "Instale o aplicativo AFun e jogue caça-níqueis, cassino ao vivo e apostas esportivas diretamente do seu celular. Desempenho rápido e bônus exclusivos para novos jogadores mobile.",
      /* prettier-ignore */
      "keyword": "cassino online México, aplicativo cassino, apostas mobile, baixar app, caça-níqueis, jogos ao vivo, bônus, experiência mobile, apostas esportivas, prêmios",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "Torneios AFun – Aposte, Compita e Ganhe Prêmios Reais",
      /* prettier-ignore */
      "description": "Participe dos torneios AFun! Aposte em esportes, suba no ranking e ganhe recompensas exclusivas. Compita com outros jogadores e receba prêmios especiais.",
      /* prettier-ignore */
      "keyword": "cassino online México, torneios, apostas esportivas, ranking, recompensas, bônus, prêmios, eventos, competições, diversão",
    },
    competition: {
      /* prettier-ignore */
      "title": "🏆 AFun Torneio de Apostas - Dispute Prêmios Exclusivos",
      /* prettier-ignore */
      "description": "articipe dos torneios de apostas da AFun. Suba no ranking, acumule pontos e conquiste prêmios exclusivos em slots e apostas esportivas.",
      /* prettier-ignore */
      "keyword": "torneio de apostas, competição cassino, ranking de jogadores, prêmios exclusivos, apostas esportivas",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "AFun Jogos Quentes – Os Mais Populares do Cassino Online",
      /* prettier-ignore */
      "description": "Conheça os jogos mais populares do AFun México! Caça-níqueis em alta, roleta ao vivo e jackpots que estão conquistando os jogadores.",
      /* prettier-ignore */
      "keyword": "cassino online México, jogos populares, caça-níqueis, roleta, jackpots, jogos em alta, apostas, diversão, jogos ao vivo, prêmios",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "AFun Jogos Casuais – Diversão Rápida e Fácil no Cassino Online",
      /* prettier-ignore */
      "description": "Relaxe com os jogos casuais da AFun México! Jogos leves, fáceis de jogar e cheios de diversão imediata. Ideal para momentos rápidos e experiências mobile.",
      /* prettier-ignore */
      "keyword": "cassino online México, jogos casuais, jogos leves, diversão rápida, mini jogos, mobile, entretenimento, caça-níqueis simples, prêmios, jogos instantâneos",
    },
    vip: {
      /* prettier-ignore */
      "title": "AFun VIP – Programa de Recompensas e Bônus Exclusivos",
      /* prettier-ignore */
      "description": "Faça parte do AFun VIP México e aproveite benefícios exclusivos: cashback, bônus personalizados e atendimento prioritário. Um programa feito para jogadores de alto nível.",
      /* prettier-ignore */
      "keyword": "cassino online México, programa VIP, bônus exclusivos, cashback, recompensas, fidelidade, jogadores premium, benefícios, apostas, prêmios",
    },
    providers: {
      /* prettier-ignore */
      "title": "AFun Fornecedores – Jogue com os Melhores Desenvolvedores de Cassino",
      /* prettier-ignore */
      "description": "Conheça os fornecedores oficiais da AFun México, como Pragmatic Play, Evolution, NetEnt e Microgaming. Jogos licenciados, seguros e com alta qualidade.",
      /* prettier-ignore */
      "keyword": "cassino online México, fornecedores de jogos, Pragmatic Play, Evolution, NetEnt, Microgaming, jogos certificados, cassino ao vivo, parceiros oficiais, caça-níqueis",
    },
    responsible: {
      /* prettier-ignore */
      "title": "AFun Jogo Responsável – Aposte com Segurança e Controle",
      /* prettier-ignore */
      "description": "A AFun México incentiva o jogo responsável. Defina limites, jogue com equilíbrio e aproveite o cassino de forma segura. Conheça nossas ferramentas de proteção ao jogador.",
      /* prettier-ignore */
      "keyword": "cassino online México, jogo responsável, segurança, controle, limites de jogo, proteção ao jogador, conscientização, apostas seguras, equilíbrio, suporte",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "AFun Centro de Bônus – Promoções Exclusivas e Recompensas Semanais",
      /* prettier-ignore */
      "description": "Acesse o Centro de Bônus AFun México e aproveite promoções diárias e semanais. Ganhe giros grátis, bônus de depósito e cashback para jogadores fiéis.",
      /* prettier-ignore */
      "keyword": "cassino online México, centro de bônus, promoções, giros grátis, cashback, recompensas, ofertas exclusivas, fidelidade, bônus de depósito, prêmios",
    },
    notify: {
      /* prettier-ignore */
      "title": "AFun Notificações – Fique por Dentro das Últimas Novidades",
      /* prettier-ignore */
      "description": "Veja suas notificações do AFun México e acompanhe atualizações, promoções e alertas de bônus. Não perca nenhuma oferta exclusiva do seu cassino favorito.",
      /* prettier-ignore */
      "keyword": "cassino online México, notificações, promoções, bônus, alertas, novidades, mensagens, recompensas, eventos, avisos",
    },
    menu: {
      /* prettier-ignore */
      "title": "AFun Menu – Explore Todos os Jogos e Recursos do Cassino",
      /* prettier-ignore */
      "description": "Acesse o menu completo do AFun México e descubra jogos de cassino, bônus, apostas esportivas e promoções exclusivas. Tudo o que você precisa em um só lugar.",
      /* prettier-ignore */
      "keyword": "cassino online México, menu do site, jogos de cassino, promoções, apostas esportivas, categorias, navegação, bônus, entretenimento, prêmios",
    },
    settings: {
      /* prettier-ignore */
      "title": "AFun Configurações – Gerencie Sua Conta e Preferências",
      /* prettier-ignore */
      "description": "Personalize sua experiência no AFun México. Ajuste idioma, notificações e privacidade, garantindo total controle e segurança da sua conta.",
      /* prettier-ignore */
      "keyword": "cassino online México, configurações, segurança, preferências, notificações, idioma, conta, controle, privacidade, jogador",
    },
    help: {
      /* prettier-ignore */
      "title": "AFun Ajuda – Suporte ao Jogador e Perguntas Frequentes",
      /* prettier-ignore */
      "description": "Precisa de ajuda? Acesse o centro de suporte AFun México para dúvidas, orientações de conta e atendimento 24 horas. Estamos aqui para garantir sua melhor experiência.",
      /* prettier-ignore */
      "keyword": "cassino online México, ajuda, suporte, atendimento ao cliente, perguntas frequentes, contato AFun, assistência, conta, FAQ, suporte 24h",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "AFun Jogos de Bônus – Giros Grátis e Grandes Recompensas",
      /* prettier-ignore */
      "description": "Descubra os jogos de bônus do AFun México! Caça-níqueis com giros grátis, rodadas especiais e multiplicadores que aumentam seus ganhos.",
      /* prettier-ignore */
      "keyword": "cassino online México, jogos de bônus, giros grátis, rodadas especiais, jackpots, multiplicadores, recompensas, caça-níqueis, diversão, prêmios",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "AFun Programa de Afiliados – Lucre com o Melhor Cassino Online do México",
      /* prettier-ignore */
      "description": "Torne-se parceiro da AFun México e ganhe comissões atrativas. Programa de afiliados com CPA, RevShare e ferramentas de acompanhamento em tempo real.",
      /* prettier-ignore */
      "keyword": "cassino online México, programa de afiliados, marketing de afiliados, CPA, RevShare, comissões, parceiros, ganhos, promoção de cassino, renda online",
    },
    promotion: {
      /* prettier-ignore */
      "title": "AFun Promoções – Bônus Exclusivos e Ofertas Especiais",
      /* prettier-ignore */
      "description": "Confira as promoções do AFun México! Bônus de boas-vindas, giros grátis e recompensas semanais para jogadores ativos. Aproveite ofertas por tempo limitado.",
      /* prettier-ignore */
      "keyword": "cassino online México, promoções, bônus exclusivos, giros grátis, cashback, ofertas especiais, recompensas, prêmios, apostas, eventos ativos",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    nobru: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "AFun Redefinir Conta – Recupere Seu Acesso com Segurança",
      /* prettier-ignore */
      "description": "Esqueceu sua senha? Utilize a página de redefinição do AFun México para recuperar o acesso à sua conta com total segurança e volte a jogar rapidamente.",
      /* prettier-ignore */
      "keyword": "cassino online México, redefinir senha, recuperar conta, acesso seguro, suporte, login, segurança, ajuda, jogador, conta",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "Bônus e Promoções AFUNS – Regras e Condições",
      /* prettier-ignore */
      "description": "Descubra os bônus e promoções da AFUNS: conheça requisitos de participação, condições de apostas e regras para resgatar suas recompensas de forma fácil no nosso cassino online.",
      /* prettier-ignore */
      "keyword": "AFUNS, bônus de cassino, regras de bônus, promoções, requisitos de apostas, cassino online, México",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "AFun Esportes – Aposte em Futebol, Basquete e eSports com Altas Cotações",
      /* prettier-ignore */
      "description": "Viva a emoção das apostas esportivas no AFun México! Futebol, basquete e eSports com odds altas, apostas ao vivo e promoções exclusivas para apostadores.",
      /* prettier-ignore */
      "keyword": "cassino online México, apostas esportivas, futebol, basquete, eSports, odds altas, apostas ao vivo, promoções, prêmios, esportes",
    },
  },
  es: {
    home: {
      /* prettier-ignore */
      "title": "AFun México – Casino Online y Apuestas Deportivas con Bonos Exclusivos",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, apuestas deportivas, tragamonedas, bonos exclusivos, SPEI, OXXO Pay, Visa, Mastercard, ruleta en vivo, juegos online",
    },
    casino: {
      /* prettier-ignore */
      "title": "AFUN Casino Online México — Tragamonedas, Ruleta, Blackjack y Bonos Exclusivos",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, tragamonedas, ruleta, blackjack, bonos sin depósito, apuestas deportivas, casino en vivo, juegos de azar",
    },
    profile: {
      /* prettier-ignore */
      "title": "AFun México – Perfil del Jugador y Configuración de Cuenta",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, perfil del jugador, cuenta, historial de apuestas, depósitos, retiros, SPEI, OXXO Pay, Visa, Mastercard",
    },
    collections: {
      /* prettier-ignore */
      "title": "AFun México – Colecciones de Juegos y Tragamonedas Populares",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, tragamonedas, ruleta, bonos exclusivos, juegos populares, jackpots, juegos en vivo, promociones, casino en línea, premios",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "AFun México – Mi Perfil y Configuración de Jugador",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, mi perfil, cuenta jugador, historial de juegos, seguridad, bonos, recompensas, perfil personal, experiencia casino, juegos online",
    },
    feedback: {
      /* prettier-ignore */
      "title": "AFun México – Opiniones y Sugerencias de Jugadores",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, opiniones jugadores, comentarios, sugerencias, soporte, experiencia usuario, confianza, reseñas, contacto, satisfacción",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "Juegos Personalizados AFUN — Casino Online México | Tragamonedas y Apuestas Deportivas",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, tragamonedas, apuestas deportivas, juegos personalizados, ruleta, blackjack, bonos AFUN",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "AFun México – Juegos Recientes y Favoritos para Seguir Jugando",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, juegos recientes, tragamonedas, ruleta, jackpots, favoritos, historial jugador, juegos online, experiencia, diversión",
    },
    install: {
      /* prettier-ignore */
      "title": "AFun México App – Descarga y Juega en Tu Celular",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, app casino, juegos móviles, descargar app, tragamonedas, apuestas deportivas, bonos exclusivos, ruleta, juegos online, experiencia móvil",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "AFun México – Torneos de Apuestas y Premios Exclusivos",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, torneos, apuestas deportivas, ranking, premios, bonos exclusivos, concursos, eventos, juegos en vivo, recompensas",
    },
    tournament: {
      /* prettier-ignore */
      "title": "🏆 AFun Torneo de Apuestas - Gana Premios Exclusivos",
      /* prettier-ignore */
      "description": "Únete a los torneos de apuestas de AFun. Sube en la clasificación, acumula puntos y gana premios exclusivos en tragamonedas y apuestas deportivas.",
      /* prettier-ignore */
      "keyword": "torneo de apuestas, competencia casino, ranking jugadores, premios exclusivos, apuestas deportivas",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "AFun México – Juegos Populares y Tragamonedas Más Calientes",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, juegos populares, tragamonedas, ruleta en vivo, jackpots, juegos calientes, bonos, premios, apuestas, entretenimiento",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "AFun México – Juegos Casuales y Rápidos para Divertirte al Instante",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, juegos casuales, mini juegos, diversión rápida, tragamonedas, juegos fáciles, entretenimiento, juegos móviles, casino en línea, ocio",
    },
    vip: {
      /* prettier-ignore */
      "title": "AFun México VIP – Bonos Exclusivos y Recompensas para Jugadores Premium",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, programa VIP, bonos exclusivos, cashback, recompensas, fidelidad, jugadores premium, beneficios, apuestas, premios",
    },
    providers: {
      /* prettier-ignore */
      "title": "AFun México – Proveedores Oficiales de Juegos de Casino",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, proveedores de juegos, Pragmatic Play, Evolution Gaming, NetEnt, Microgaming, juegos certificados, casino en vivo, software, tragamonedas, confianza",
    },
    responsible: {
      /* prettier-ignore */
      "title": "AFun México – Juego Responsable y Seguridad del Jugador",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, juego responsable, seguridad del jugador, control, límites, ayuda, prevención, soporte, juego seguro, responsabilidad",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "AFun México – Centro de Bonos y Promociones Exclusivas",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, centro de bonos, promociones, giros gratis, cashback, recompensas, ofertas exclusivas, bonos de depósito, lealtad, premios",
    },
    notify: {
      /* prettier-ignore */
      "title": "AFun México – Centro de Notificaciones y Promociones Activas",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, notificaciones, alertas, bonos, promociones activas, torneos, novedades, recompensas, mensajes, avisos",
    },
    menu: {
      /* prettier-ignore */
      "title": "AFun México – Menú del Sitio con Juegos, Bonos y Promociones",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, menú del sitio, juegos de casino, bonos, promociones, apuestas deportivas, navegación, categorías, entretenimiento, juegos online",
    },
    settings: {
      /* prettier-ignore */
      "title": "AFun México – Configuración de Cuenta y Preferencias del Jugador",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, configuración, ajustes de cuenta, notificaciones, privacidad, idioma, seguridad, control, jugador, preferencias",
    },
    help: {
      /* prettier-ignore */
      "title": "AFun México – Centro de Ayuda y Soporte al Jugador",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, ayuda, soporte, atención al cliente, preguntas frecuentes, contacto AFun, asistencia, cuenta, FAQ, servicio 24 horas",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "AFun México – Juegos con Bonos y Giros Gratis",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, juegos con bono, giros gratis, tragamonedas, rondas especiales, jackpots, multiplicadores, premios, casino en línea, diversión",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "AFun México – Programa de Afiliados con Altas Comisiones",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, programa de afiliados, marketing de afiliación, CPA, RevShare, comisiones, socios, ganar dinero, promoción, afiliados de casino",
    },
    promotion: {
      /* prettier-ignore */
      "title": "AFun México – Promociones Activas y Bonos Exclusivos",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, promociones, bonos exclusivos, giros gratis, cashback, ofertas activas, recompensas, casino en línea, premios, eventos especiales",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    nobru: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "AFun México – Restablecer Contraseña y Recuperar Cuent",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, restablecer contraseña, recuperar cuenta, acceso seguro, ayuda, soporte, jugador, seguridad, login, recuperación",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "Bonos y Promociones AFUNS – Reglas de Bonificación y Condiciones",
      /* prettier-ignore */
      "description": "Descubre en AFUNS todas las reglas de bonificación, términos y condiciones de tus promociones favoritas. Conoce cómo obtener y liberar tus bonos fácilmente en nuestro casino en línea.",
      /* prettier-ignore */
      "keyword": "AFUNS, bonos de casino, reglas de bonificación, promociones, apuestas en línea, términos y condiciones, casino México",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "AFun México – Apuestas Deportivas con Cuotas Altas y Promociones",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "casino online México, apuestas deportivas, futbol, basquetbol, eSports, cuotas altas, apuestas en vivo, bonos, promociones, deportes",
    },
  },
  hk: {
    home: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 在線賭場與體育博彩平台",
      /* prettier-ignore */
      "description": "體驗 AFun 墨西哥領先的在線賭場。暢玩老虎機、真人遊戲與體育投注，享受安全支付（SPEI / OXXO Pay / Visa / Mastercard）與專屬紅利優惠。",
      /* prettier-ignore */
      "keyword": "在線賭場, 體育博彩, 真人遊戲, SPEI, OXXO Pay, Visa, Mastercard, 紅利, 墨西哥博彩, 娛樂遊戲",
    },
    casino: {
      /* prettier-ignore */
      "title": "AFUN 墨西哥線上賭場｜老虎機・輪盤・二十一點・真人娛樂",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "墨西哥線上賭場, 老虎機, 真人娛樂, 體育博彩, 線上輪盤, AFUN 賭場, 現金紅利",
    },
    profile: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 帳戶資料與投注紀錄管理",
      /* prettier-ignore */
      "description": "登入 AFun 墨西哥帳戶以查看投注紀錄、存取紀錄與個人資訊。支援 SPEI / OXXO Pay / Visa / Mastercard 安全支付與提款。",
      /* prettier-ignore */
      "keyword": "在線賭場, 玩家帳戶, 投注紀錄, 安全支付, SPEI, OXXO Pay, Visa, Mastercard, 墨西哥博彩, 個人資料",
    },
    collections: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 精選遊戲合集與熱門老虎機",
      /* prettier-ignore */
      "description": "探索 AFun 精選遊戲合集，包含熱門老虎機、真人賭場與高獎金遊戲。每日更新，發掘新鮮娛樂體驗。",
      /* prettier-ignore */
      "keyword": "在線賭場, 老虎機, 真人遊戲, 紅利, 熱門遊戲, 累積獎金, 墨西哥博彩, 娛樂, 高獎勵, 新遊戲",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 我的帳戶與個人遊戲資料",
      /* prettier-ignore */
      "description": "登入 AFun 墨西哥帳戶以查看遊戲紀錄、個人資料與紅利設定，享受安全且個性化的娛樂體驗。",
      /* prettier-ignore */
      "keyword": "在線賭場, 玩家帳戶, 個人資料, 遊戲紀錄, 安全, 紅利, 墨西哥博彩, 娛樂, 經驗, 會員中心",
    },
    feedback: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 用戶回饋與意見中心",
      /* prettier-ignore */
      "description": "分享您在 AFun 墨西哥的遊戲體驗，提交建議或意見以幫助我們改進。您的反饋對我們非常重要。",
      /* prettier-ignore */
      "keyword": "在線賭場, 玩家反饋, 意見中心, 使用體驗, 客戶支援, 評價, 信任, 墨西哥博彩, 改進, 服務品質",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "AFUN 專屬遊戲｜墨西哥線上賭場・老虎機・體育博彩",
      /* prettier-ignore */
      "description": "在享受專屬遊戲體驗！提供墨西哥最熱門的線上老虎機、真人娛樂與體育投注，天天都有專屬獎金與活動等你參加。",
      /* prettier-ignore */
      "keyword": "墨西哥線上賭場, 老虎機, 體育博彩, 真人娛樂, AFUN 專屬遊戲, 獎金, 在線娛樂",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 最近遊玩與熱門遊戲記錄",
      /* prettier-ignore */
      "description": "一鍵回到您在 AFun 墨西哥玩過的熱門遊戲！快速進入老虎機、真人遊戲與累積獎金項目，延續您的娛樂體驗。",
      /* prettier-ignore */
      "keyword": "在線賭場, 最近遊戲, 老虎機, 真人遊戲, 熱門遊戲, 玩家紀錄, 墨西哥博彩, 娛樂, 遊戲體驗, 收藏",
    },
    install: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 App – 手機版在線賭場下載",
      /* prettier-ignore */
      "description": "立即下載 AFun 墨西哥 App，暢玩老虎機、真人賭場與體育博彩。體驗流暢操作與專屬手機紅利，隨時隨地開啟娛樂之旅。",
      /* prettier-ignore */
      "keyword": "在線賭場, 手機賭場, APP下載, 老虎機, 真人遊戲, 體育博彩, 專屬紅利, 墨西哥博彩, 手機娛樂, 遊戲體驗",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 體育競猜與獎金挑戰活動",
      /* prettier-ignore */
      "description": "參加 AFun 墨西哥的體育競猜與錦標賽，投注熱門賽事、登上排行榜並贏取豐厚獎金！",
      /* prettier-ignore */
      "keyword": "在線賭場, 體育競猜, 錦標賽, 排行榜, 獎金, 比賽, 獎勵, 墨西哥博彩, 活動, 娛樂",
    },
    competition: {
      /* prettier-ignore */
      "title": "🏆 AFun 投注競賽 - 爭奪專屬獎勵",
      /* prettier-ignore */
      "description": "參加 AFun 投注競賽。提升玩家排名，累積積分，在老虎機與體育博彩中贏取專屬獎勵。",
      /* prettier-ignore */
      "keyword": "投注競賽, 娛樂城比賽, 玩家排名, 專屬獎勵, 體育博彩",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 熱門遊戲與高獎勵老虎機",
      /* prettier-ignore */
      "description": "探索 AFun 墨西哥最受歡迎的遊戲！暢玩熱門老虎機、真人賭場與累積獎金遊戲，體驗玩家最愛的娛樂盛宴。",
      /* prettier-ignore */
      "keyword": "在線賭場, 熱門遊戲, 老虎機, 真人遊戲, 累積獎金, 玩家最愛, 娛樂, 墨西哥博彩, 高獎勵, 娛樂平台",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 輕鬆遊戲與即玩娛樂體驗",
      /* prettier-ignore */
      "description": "享受 AFun 墨西哥的輕鬆娛樂遊戲！無需複雜規則即可開玩，體驗快速樂趣與即時獎勵，最適合手機玩家。",
      /* prettier-ignore */
      "keyword": "在線賭場, 輕鬆遊戲, 迷你遊戲, 即時娛樂, 快速遊玩, 老虎機, 手機遊戲, 娛樂體驗, 墨西哥博彩, 快樂遊戲",
    },
    vip: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 VIP – 專屬紅利與高級會員獎勵",
      /* prettier-ignore */
      "description": "加入 AFun 墨西哥 VIP 俱樂部，尊享現金回饋、專屬紅利與快速提款特權。為高級玩家打造的頂級娛樂體驗。",
      /* prettier-ignore */
      "keyword": "在線賭場, VIP會員, 專屬紅利, 現金回饋, 高級玩家, 特權, 墨西哥博彩, 忠誠計劃, 娛樂獎勵, 頂級體驗",
    },
    providers: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 官方合作遊戲供應商",
      /* prettier-ignore */
      "description": "AFun 墨西哥與 Pragmatic Play、Evolution、NetEnt、Microgaming 等頂級品牌合作，提供經認證的老虎機與真人賭場遊戲。",
      /* prettier-ignore */
      "keyword": "在線賭場, 遊戲供應商, Pragmatic Play, Evolution, NetEnt, Microgaming, 官方授權, 真人遊戲, 老虎機, 墨西哥博彩, 品牌合作",
    },
    responsible: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 負責任博彩與玩家安全",
      /* prettier-ignore */
      "description": "AFun 墨西哥致力於推廣負責任博彩。玩家可設定限額與休息時間，確保安全健康的娛樂體驗，並提供完善支援與輔導資源。",
      /* prettier-ignore */
      "keyword": "在線賭場, 負責任博彩, 玩家安全, 自我控制, 限額設定, 健康遊戲, 輔導支援, 安全娛樂, 墨西哥博彩, 責任遊戲",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 獎金中心與專屬優惠",
      /* prettier-ignore */
      "description": "前往 AFun 墨西哥獎金中心，領取每日與每週紅利！包含免費旋轉、存款獎金與現金回饋，專為忠實玩家打造。",
      /* prettier-ignore */
      "keyword": "在線賭場, 獎金中心, 紅利, 免費旋轉, 現金回饋, 專屬優惠, 忠誠獎勵, 墨西哥博彩, 活動促銷, 獎勵系統",
    },
    notify: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 通知中心與最新活動提醒",
      /* prettier-ignore */
      "description": "查看 AFun 墨西哥的通知中心，隨時掌握最新紅利、促銷與比賽資訊，不錯過任何娛樂機會。",
      /* prettier-ignore */
      "keyword": "在線賭場, 通知中心, 活動提醒, 紅利, 促銷, 最新消息, 玩家訊息, 墨西哥博彩, 娛樂更新, 比賽資訊",
    },
    menu: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 網站選單與完整娛樂導航",
      /* prettier-ignore */
      "description": "瀏覽 AFun 墨西哥的完整選單，快速進入老虎機、真人賭場、體育投注與紅利活動，一站式娛樂入口。",
      /* prettier-ignore */
      "keyword": "在線賭場, 網站選單, 娛樂導航, 老虎機, 體育博彩, 紅利, 分類, 墨西哥博彩, 真人遊戲, 一站式娛樂",
    },
    settings: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 帳戶設定與偏好管理",
      /* prettier-ignore */
      "description": "管理您的 AFun 墨西哥帳戶設定，包含語言、通知與隱私選項，打造安全且個人化的娛樂體驗。",
      /* prettier-ignore */
      "keyword": "在線賭場, 帳戶設定, 偏好, 通知, 隱私, 安全, 玩家控制, 墨西哥博彩, 個人化, 娛樂平台",
    },
    help: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 幫助中心與客服支援",
      /* prettier-ignore */
      "description": "有疑問嗎？前往 AFun 墨西哥幫助中心，查看常見問題與帳戶指引。客戶服務團隊全年無休，隨時為您提供協助。",
      /* prettier-ignore */
      "keyword": "在線賭場, 幫助中心, 客服, 常見問題, 支援, 帳戶協助, 聯絡AFun, 玩家支援, 墨西哥博彩, 即時服務",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 獎金遊戲與免費旋轉體驗",
      /* prettier-ignore */
      "description": "暢玩 AFun 墨西哥的獎金遊戲！體驗免費旋轉、倍數加成與獎池模式，感受滿滿娛樂與豐厚獎勵。",
      /* prettier-ignore */
      "keyword": "在線賭場, 獎金遊戲, 免費旋轉, 老虎機, 倍數加成, 特殊回合, 獎金, 墨西哥博彩, 娛樂遊戲, 贏取獎勵",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 聯盟計劃與收益分成合作",
      /* prettier-ignore */
      "description": "加入 AFun 墨西哥聯盟計劃，推廣頂級在線賭場並獲取高額分成。支援 CPA / RevShare 模式，長期穩定收益。",
      /* prettier-ignore */
      "keyword": "在線賭場, 聯盟計劃, 推廣合作, 收益分成, CPA, RevShare, 合作夥伴, 墨西哥博彩, 聯盟行銷, 賺取佣金",
    },
    promotion: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 最新促銷與專屬紅利",
      /* prettier-ignore */
      "description": "探索 AFun 墨西哥的限時促銷活動！包含歡迎紅利、免費旋轉與每週回饋，專為活躍玩家打造的專屬優惠。",
      /* prettier-ignore */
      "keyword": "在線賭場, 促銷活動, 專屬紅利, 免費旋轉, 現金回饋, 優惠, 墨西哥博彩, 奖励, 活動, 娛樂優惠",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    nobru: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 帳戶重設與密碼找回",
      /* prettier-ignore */
      "description": "忘記密碼？前往 AFun 墨西哥帳戶重設頁面，安全恢復登入權限，立即繼續您的娛樂體驗。",
      /* prettier-ignore */
      "keyword": "在線賭場, 帳戶重設, 密碼找回, 安全登入, 玩家支援, 賬號恢復, 安全驗證, 墨西哥博彩, 幫助中心, 登入協助",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "AFUNS 獎金與優惠 – 規則與使用條款",
      /* prettier-ignore */
      "description": "在 AFUNS 探索最新獎金與促銷活動規則，清楚了解投注條件、流水要求及使用條款，輕鬆領取您的專屬優惠。",
      /* prettier-ignore */
      "keyword": "AFUNS, 獎金, 紅利規則, 優惠活動, 投注要求, 流水規則, 在線娛樂",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "AFun 墨西哥 – 體育博彩與高賠率投注",
      /* prettier-ignore */
      "description": "在 AFun 墨西哥體驗體育博彩！涵蓋足球、籃球與電子競技，提供高賠率與即時投注，贏取專屬紅利。",
      /* prettier-ignore */
      "keyword": "在線賭場, 體育博彩, 足球投注, 籃球, 電子競技, 即時投注, 高賠率, 墨西哥博彩, 紅利, 娛樂體驗",
    },
  },
  __EMPTY: {
    home: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    casino: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    profile: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    collections: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    feedback: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    install: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    vip: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    providers: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    responsible: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    notify: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    menu: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    settings: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    help: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    promotion: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    nobru: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
  },
};
